module.exports = __webpack_public_path__ + "static/media/TBSCarharttFRMensJacketsSizing.8502dbaa.pdf";